import { DrilldownFieldType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import _ from 'lodash'

export const parseTypedValue = (
  value: string,
  type: DrilldownFieldType,
  warningMessage?: (message: string) => void
): string | number | boolean | Date | Record<string, unknown> | unknown[] => {
  switch (type) {
    case 'number':
      return parseFloat(value)
    case 'boolean':
      return value === 'true'
    case 'date':
      return value
    case 'object':
      try {
        const parsed = JSON.parse(value)
        if (
          typeof parsed !== 'object' ||
          parsed === null ||
          Array.isArray(parsed)
        ) {
          const errorMsg = 'Value must be a JSON object'
          console.error(errorMsg, { value, type })
          warningMessage?.(errorMsg)
          return value
        }
        return parsed
      } catch {
        const errorMsg = 'Invalid JSON object format'
        console.error(errorMsg, { value, type })
        warningMessage?.(errorMsg)
        return value
      }
    case 'array':
      try {
        const parsed = JSON.parse(value)
        if (!Array.isArray(parsed)) {
          const errorMsg = 'Value must be a JSON array'
          console.error(errorMsg, { value, type })
          warningMessage?.(errorMsg)
          return value
        }
        return parsed
      } catch {
        const errorMsg = 'Invalid JSON array format'
        console.error(errorMsg, { value, type })
        warningMessage?.(errorMsg)
        return value
      }
    case 'text':
    case 'enum':
    default:
      return value
  }
}

export const getPropertyKey = (
  isEditingCustomProperty: boolean,
  customPropertyName: string,
  selectedField: string
): string | null => {
  if (isEditingCustomProperty) {
    return customPropertyName
  }
  const selectedFieldParts = selectedField.split('.')
  if (selectedFieldParts.length < 2) {
    console.error('Invalid selected field', { selectedField })
    return null
  }
  return selectedFieldParts[1]
}

export const getNewValue = (
  entryId: string,
  editedValues: Record<string, unknown>,
  shouldPrefillValues: boolean,
  prefillValue: string,
  currentValue: unknown
): unknown => {
  // User-edited value takes precedence
  if (editedValues[entryId] !== undefined) {
    return editedValues[entryId]
  }
  // Then prefilled value
  if (shouldPrefillValues && prefillValue) {
    return prefillValue
  }
  // Finally current value
  return currentValue
}

export const hasValueChanged = (
  newValue: unknown,
  currentValue: unknown
): boolean => {
  return !_.isEqual(newValue, currentValue)
}
